import React from "react";
import { Button } from "@moai/core";
import { Icon } from "@moai/core";
import s from "./format.module.scss";

const cmd =
    "M12 9h-1V7h1c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3v1H7V4c0-1.66-1.34-3-3-3S1 2.34 1 4s1.34 3 3 3h1v2H4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3v-1h2v1c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3zm0-6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5 4H7V7h2v2zm3 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z";
const ctrl =
    "M12.71 5.29l-4-4C8.53 1.11 8.28 1 8 1s-.53.11-.71.29l-4 4a1.003 1.003 0 001.42 1.42L8 3.41l3.29 3.29c.18.19.43.3.71.3a1.003 1.003 0 00.71-1.71z";
const enter =
    "M14 2c-.55 0-1 .45-1 1v3c0 1.66-1.34 3-3 3H4.41L5.7 7.71c.19-.18.3-.43.3-.71a1.003 1.003 0 00-1.71-.71l-3 3c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l3 3a1.003 1.003 0 001.42-1.42L4.41 11H10c2.76 0 5-2.24 5-5V3c0-.55-.45-1-1-1z";

const isApple =
    navigator.platform &&
    (navigator.platform.startsWith("Mac") ||
        navigator.platform.startsWith("iPad") ||
        navigator.platform.startsWith("iPhone"));

const Shortcut = () => (
    <span className={s.icon}>
        <Icon path={isApple ? cmd : ctrl} />
        <span style={{ width: 4 }} />
        <Icon path={enter} />
    </span>
);

interface Props {
    format: () => void;
}

export const Format: React.FC<Props> = ({ format }) => (
    <Button highlight onClick={format}>
        <span className={s.label}>
            <span>Format</span>
            <Shortcut />
        </span>
    </Button>
);
